module.exports = __webpack_public_path__ + "img/usability-2.0281ca2f.png";